import { formatPrice as originalFormatPrice, formatIntPrice } from "./domains2/libraries/Utils";
import appConfig from "./appconfig";

const toUpperCase = value => {
	if(typeof value === "string") {
		return value.toUpperCase();
	}

	return value;
};

const formatPrice =(() => {
	if (appConfig.isBM6()) {
		return formatIntPrice;
	}
	return originalFormatPrice;
})();

const capitalize = value => {
	if (!value) return "";
	value = value.toString();
	return value.charAt(0).toUpperCase() + value.slice(1);
};

export default {
	formatPrice,
	formatIntPrice,
	toUpperCase,
	capitalize
};
